export default "__VITE_ASSET__c6cd3cbd__"